"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectUserContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../molecules");

var _helpers = require("../../util/helpers");

var _atoms = require("../../atoms");

require("./SelectUserContent.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var SelectUserContent = function SelectUserContent(_ref) {
  var userRelations = _ref.userRelations,
      selectFamilyMember = _ref.selectFamilyMember,
      showBadge = _ref.showBadge;
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, null, userRelations === null || userRelations === void 0 ? void 0 : userRelations.map(function (member, index) {
    var familyMember = member.user;
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      key: index,
      className: "family-member",
      marginBottom: "4",
      trkAction: "Family Member Selected",
      onClick: function onClick() {
        return selectFamilyMember(familyMember);
      }
    }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      className: "family-member-row",
      center: true
    }, /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      size: 80,
      imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(familyMember.user_id),
      initials: (0, _helpers.getInitials)(familyMember.first_name, familyMember.last_name),
      marginTop: "6",
      marginBottom: "2"
    }), showBadge && familyMember.trace_id_plan_type === "pro" && /*#__PURE__*/_react.default.createElement(_atoms.Badge, {
      className: "badge",
      color: _atoms.Color.Sky,
      padding: "0 2",
      position: _atoms.Badge.Position.BottomRight,
      size: 24,
      width: 42
    }, "Plus"), /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 24,
      type: _atoms.Icon.Type.CheveronRight,
      color: _atoms.Color.Grey3
    })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      center: true
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.Body,
      bold: true,
      content: familyMember.first_name,
      color: _atoms.Color.Black,
      marginBottom: "4"
    })));
  }));
};

exports.SelectUserContent = SelectUserContent;